import { ExternalUrlItem } from 'app/area/external-url-groups/form/types-store';

export const getPrevElement = (
  externalUrls: ExternalUrlItem[],
  index: number
) => externalUrls
  ?.slice(0, index)
  ?.reverse()
  ?.[0];

export const getNextElement = (
  externalUrls: ExternalUrlItem[],
  index: number
) => externalUrls
  ?.slice(index + 1)
  ?.[0];
